import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface IDialogConfig {
  // extends MatDialogConfig
  title?: string;
  message: string | string[];
  isLastMessageConfirmation?: boolean;
  panelClass?: string | string[];
  disableClose?: boolean;
}

export interface IAlertConfig extends IDialogConfig {
  closeButton?: string;
}

export interface IConfirmConfig extends IDialogConfig {
  acceptButton?: string;
  cancelButton?: string;
}

export interface IPromptConfig extends IConfirmConfig {
  value?: string;
}

export interface DialogType {
  type?: 'alert' | 'confirm';
}

export interface AlertConfig extends IAlertConfig, DialogType {}

export interface ConfirmConfig extends IConfirmConfig, DialogType {
  rememberKey?: string;
}

export interface ConfirmDataConfig extends AlertConfig, ConfirmConfig {}

export interface IDialogService {
  showConfirm(config: ConfirmConfig): Observable<boolean>;
  showAlert(config: AlertConfig): Observable<boolean>;
}

export interface DialogClosingParams {}

export const DIALOG_SERVICE = new InjectionToken<IDialogService>('DialogService');
